import { isEmpty } from 'lodash/fp';
import classnames from 'classnames/bind';
import { Icon, IconSize } from 'app/components/core/Icon';
import { NotAvailable } from './NotAvailable.jsx';
import * as styles from './WarehouseLoadDialog.css';

const cx = classnames.bind(styles);

const ICON_BY_STATE = {
    suspended: 'pause',
    started: 'check-circle-solid',
    overloaded: 'status-alert-solid'
};

export function StateTag({ value }) {
    if (isEmpty(value)) {
        return <NotAvailable />;
    }

    const state = value.toLowerCase();
    const icon = ICON_BY_STATE[state];

    return (
        <div className={cx('state-tag', state)}>
            {icon && <Icon variant={icon} size={IconSize.EXTRA_SMALL} />}
            {state.toLowerCase()}
        </div>
    );
}
